import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { ExternalLink } from '../../external-link'
import withAnalytics from '../../analytics/with-analytics'
// import { fptiRecordOnClick } from '../../../../utils/fpti-utils'

const SidenavLink = forwardRef((props, ref) => {
  const { as = Link, children, ...rest } = props

  const Component = as === 'a' ? ExternalLink : Link
  return (
    <Component
      className="dev_dash__sidenav--link"
      ref={ref}
      data-dxa={`dev_portal_left_nav,navigation_click,${children},/dashboard${
        rest?.to || '/'
      }`}
      data-cy={`sidenav-link-${children
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-')}`}
      {...rest}
    >
      {children}
    </Component>
  )
})

export default withAnalytics(SidenavLink)

SidenavLink.displayName = 'SidenavLink'

SidenavLink.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any.isRequired,
  activePath: PropTypes.string,
  to: PropTypes.string,
}
